var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stars"},_vm._l((_vm.starIconList),function(starIcon,index){return _c('span',{key:'star-'+index,staticClass:"star"},[_c('i',{staticClass:"mdi",class:starIcon})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }